<template>
  <div class="detail-container">
    <!--全部禁用 不可编辑-->
    <div class="title">基本信息</div>
    <el-container class="main-item-container info-container">
      <el-form
        :model="detailFormData"
        ref="detailFormData"
        label-width="90px"
        class="demo-detailFormData"
        disabled
      >
        <el-form-item label="机构名称" prop="name">
          <el-input v-model="detailFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="机构代码" prop="region">
          <el-input v-model="detailFormData.id"></el-input>
        </el-form-item>
        <el-form-item label="机构类型" prop="region">
          <el-input v-model="detailFormData.type"></el-input>
        </el-form-item>
        <el-form-item label="省份" prop="name">
          <el-input v-model="detailFormData.province"></el-input>
        </el-form-item>
        <el-form-item label="城市" prop="name">
          <el-input v-model="detailFormData.city"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="name">
          <el-input v-model="detailFormData.address"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input v-model="detailFormData.contact"></el-input>
        </el-form-item>
        <el-form-item label="证件号" prop="name">
          <el-input v-model="detailFormData.identity"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="name">
          <el-input v-model="detailFormData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="name">
          <el-input v-model="detailFormData.loginName"></el-input>
        </el-form-item>
        <!--<el-form-item label="密码">-->
        <!--<el-input v-model="detailFormData.name"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="学生人数">
          <el-input v-model="detailFormData.userNum"></el-input>
        </el-form-item>
        <el-form-item label="账号有效期">
          <!--<el-input v-model="detailFormData.validDate "></el-input>-->
          <el-date-picker
            class="date"
            type="date"
            placeholder="开始日期"
            style="width: 145px;"
            v-text="detailFormData.validDate"
          ></el-date-picker>
          -
          <el-date-picker
            class="date"
            type="date"
            placeholder="结束日期"
            style="width: 145px;"
            v-text="detailFormData.expireDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio v-model="detailFormData.status" :label="0">停用</el-radio>
          <el-radio v-model="detailFormData.status" :label="1">启用</el-radio>
        </el-form-item>
        <el-form-item label="承办单位">
          <el-radio v-model="detailFormData.isAgent" :label="1">是</el-radio>
          <el-radio v-model="detailFormData.isAgent" :label="0">否</el-radio>
        </el-form-item>
      </el-form>
    </el-container>
    <!--配课信息-->
    <div>
      <div class="confirm-title">
        <span>课程分配情况 &nbsp;</span>
        <!--<div class="course-btn" v-text="'爵士鼓'" v-for="i in 3" :key="i" @click = "albumDetail"></div>-->
      </div>
      <div class="organ-course">
        <el-table :data="organCourses">
          <el-table-column
            prop="title"
            label="曲目名称"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="instrument"
            label="乐器"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="book"
            label="曲册"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="chapter"
            label="章节"
            width="180"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrganDetail",
  props: ["detailId"],
  data() {
    return {
      //基本信息表单数据
      detailFormData: {},
      //  机构已添加课程
      organCourses: []
    };
  },

  created() {
    // 获取基本信息
    this.getDetailInfo(this.detailId);
    // 获取配课信息
    this.getOrganCourses(this.detailId);
  },

  methods: {
    // 机构基本信息详情
    getDetailInfo(id) {
      let param = {
        id: id
      };
      let res = this.$api.get("/customer/details.json", param); // 返回的是一个promise
      res
        .then(
          success => {
            // 成功才会有数据
            if (success.code === 200) {
              this.detailFormData = success.data;
              console.log(this.detailFormData);
            } else {
              this.$message.error("请求失败！");
            }
          },
          err => {
            this.$message.error("请求失败！");
          }
        )
        .catch(err => {
          this.$message.error("请求异常！");
        });
    },

    // 获取机构配课详情
    getOrganCourses(id) {
      // 根据机构名  获取机构id   下次要在添加的时候返回一个id么？
      let param = {
        id: id
      };
      let res = this.$api.get("/customer/course.json", param); // 返回的是一个promise
      res
        .then(
          success => {
            if (success.code === 200) {
              this.organCourses = success.data.courses;
              console.log("已添加的课程");
              console.log(this.organCourses);
            } else {
              this.$message.error("数据请求失败！");
            }
          },
          err => {
            this.$message.error("数据请求失败！");
          }
        )
        .catch(err => {
          this.$message.error("数据请求异常！");
        });
    }
  }
};
</script>

<style scoped>
.detail-container {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-item-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

/* 表单内容布局   .el-input,.select,*/
.el-input,
.select {
  width: 300px;
}

.date {
  text-align: center;
}

/*表单布局完毕*/

/* 课程分配按钮*/
.confirm-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  height: 50px;
  /*font-size: 16px;*/
  /*border: #888 solid 1px;*/
  margin-bottom: 20px;
}

.course-btn {
  display: inline-block;
  width: 60px;
  /*padding: auto;*/
  /*text-align: center;*/
  text-align: center;
  margin-left: 5px;
  line-height: 26px;
  height: 26px;
  font-size: 12px;
  border-radius: 5px;
  background-color: #409eff;
  cursor: default;
  color: #fff;
  /*border: cornflowerblue 1px solid;*/
}

.title {
  display: inline-block;
  text-align: center;
  line-height: 50px;
  margin-bottom: 20px;
}

/*配课详情*/
.organ-course {
  margin-bottom: 20px;
}

/*批量操作按钮*/
.moreBtn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organManage/OrganDetail.vue